import './style/BogleWeb'
import './style/style';
import './style/grid';
import './style/loader';
import './style/comparetable';
//import ProductModule from './components/productModule/productModule'
import Content from './components/content/content'

require('es6-promise').polyfill();

export default function App() {
		return (
			<Content />
		);

	}



// WEBPACK FOOTER //
// ./index.js